import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IHoverJobData } from "common/records/HoverJob";

export const RECEIVE_HOVER_JOBS = "@hover/RECEIVE_HOVER_JOBS";
export const RECEIVE_HOVER_JOB = "@hover/RECEIVE_HOVER_JOB";

export const HoverActions = {
  receiveHoverJobs: (jobs: Partial<IHoverJobData>[]) => createAction(RECEIVE_HOVER_JOBS, { jobs }),
  receiveHoverJob: (job: Partial<IHoverJobData>) => createAction(RECEIVE_HOVER_JOB, { job }),
};

export type HoverActions = ActionsUnion<typeof HoverActions>;
